export const SET_CHEFS = 'SET_CHEFS';
export const ADD_CHEF = 'ADD_CHEF';
export const UPDATE_CHEF = 'UPDATE_CHEF';
export const CHEF_DELETED = 'CHEF_DELETED';


// WEBPACK FOOTER //
// ./src/actions/reduxTypes.js